/** @jsx jsx */
import React, { type ReactNode, type MouseEvent } from 'react';
import { css, jsx } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';
import { SMALL_BROWSER_BREAKPOINT } from '../../constants';

type Props = {
	isSelected?: boolean;
	isDisabled?: boolean;
	icon: ReactNode;
	text: string;
	testId?: string;
	onClick?: (e: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
};

// ResponsiveButton is a workaround as atlaskit button doesn't correctly handle hiding
// the button text via css. It applies different padding depending on the number of
// children given.
const ResponsiveButton = ({ icon, text, isSelected, onClick, testId, isDisabled }: Props) => (
	<Button
		onClick={onClick}
		isSelected={isSelected}
		spacing="none"
		testId={testId}
		isDisabled={isDisabled}
	>
		<div css={buttonContentStyles}>
			{icon}
			<span css={buttonTextStyles}>{text}</span>
		</div>
	</Button>
);

const buttonTextStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	[`@media (max-width: ${SMALL_BROWSER_BREAKPOINT}px)`]: {
		display: 'none',
	},
});

const buttonContentStyles = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	height: token('space.400', '32px'),
	padding: `0 ${token('space.100', '8px')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	[`@media (max-width: ${SMALL_BROWSER_BREAKPOINT}px)`]: {
		padding: `0 ${token('space.025', '2px')}`,
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > span': {
		padding: `0 ${token('space.025', '2px')}`,
	},
});

export default ResponsiveButton;
